'use client';

import { Progress } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';
import useSubscription from '@/hooks/useSubscription';
import { useTranslation } from '@/i18n/client';

import styles from './index.less';

interface IRCProps {
  className?: string;
}

const RemainCredits = (props: IRCProps) => {
  const { className } = props;

  const { memoriesUsageString, memoriesPercent, messagesPercent, messagesUsageString } =
    useSubscription((state) => state.computed);
  const currentPlanDetail = useSubscription((state) => state.currentPlanDetail);

  const { t } = useTranslation();
  const [layoutSize] = useStorage('layoutSize');
  const [inMobile, setInMobile] = useState(layoutSize === LAYOUT_SIZE.SMALL);

  useEffect(() => {
    setInMobile(layoutSize === LAYOUT_SIZE.SMALL);
  }, [layoutSize]);

  return (
    <div className={classNames(styles.container, className)}>
      <div className="font-medium text-sm leading-6 text-primary-black">
        {t('menu.subscriptionModal.remainingQuota')}
      </div>
      {currentPlanDetail?.unlimitedExpireDate ? (
        <div className="text-xs leading-5 text-[#afaeae]">
          {t('menu.subscriptionModal.referralBonus', {
            date: currentPlanDetail.unlimitedExpireDate
          })}
        </div>
      ) : null}

      <div className={classNames(styles.progressContainer, inMobile ? 'flex-col' : '')}>
        <div className={styles.usageContainer}>
          <div className={styles.topContainer}>
            <div className={styles.title}>{t('menu.subscriptionModal.newMemories')}</div>
            <div className={styles.usage}>{t(memoriesUsageString)}</div>
          </div>
          <Progress
            className={styles.progress}
            percent={memoriesPercent}
            showInfo={false}
            strokeColor={'#a99df5'}
            trailColor={'#eee9e4'}
          />
        </div>

        {/* Messages */}
        <div className={styles.usageContainer}>
          <div className={styles.topContainer}>
            <div className={styles.title}>{t('menu.subscriptionModal.messages')}</div>
            <div className={styles.usage}>{t(messagesUsageString)}</div>
          </div>
          <Progress
            className={styles.progress}
            percent={messagesPercent}
            showInfo={false}
            strokeColor={'#a99df5'}
            trailColor={'#eee9e4'}
          />
        </div>
      </div>
    </div>
  );
};

export default RemainCredits;
